import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';
import { useAuth } from '../AuthContext';
import { showToast } from './Toast';
import { hasDownloadOption, buildCartItem } from '../utils/productVariants';
import './ProductCard.css';

function ProductCard({ product }) {
  const { addToCart } = useCart();
  const { currentUser, isMember, getMemberPrice } = useAuth();
  const navigate = useNavigate();

  const handleProductClick = (e) => {
    // Prevent navigation if clicking on the add to cart button
    if (e.target.closest('.add-to-cart-btn')) {
      return;
    }
    navigate(`/product/${product.id}`);
  };

  const handleAddToCart = (e) => {
    e.stopPropagation(); // Prevent triggering the product click
    // Products with a download option need the format chosen on the product page
    if (hasDownloadOption(product)) {
      navigate(`/product/${product.id}`);
      return;
    }
    try {
      console.log('Adding to cart:', product);
      const cartItem = buildCartItem(product, 'physical');
      addToCart(cartItem);
      console.log('Successfully added to cart');
      // Show visual feedback with toast notification
      showToast(`${product.name} added to basket!`, 'success');
    } catch (error) {
      console.error('Error adding to cart:', error);
      showToast('Failed to add item to basket. Please try again.', 'error');
    }
  };

  const formatPrice = (price) => {
    return `${price} SEK`;
  };

  // Ensure price is a valid number
  const originalPrice = product.price || 0;
  const memberPrice = product.memberPrice || getMemberPrice(originalPrice);
  const displayPrice = currentUser && isMember() && originalPrice > 0 ? memberPrice : originalPrice;
  const showMemberDiscount = currentUser && isMember() && memberPrice < originalPrice;

  const getCategoryLabel = (category) => {
    switch (category) {
      case 'tickets': return 'EVENT TICKET';
      case 'merchandise': return 'MERCH';
      case 'crafts': return 'HANDMADE';
      case 'recordings': return 'DIGITAL';
      default: return category.toUpperCase();
    }
  };

  return (
    <div className="product-card" onClick={handleProductClick} style={{ cursor: 'pointer' }}>
      <div className="product-image">
        <img src={product.thumbnailUrl || product.imageUrl || product.image} alt={product.name} />
      </div>
      
      <div className="product-info">
        <h3 className="product-name">{product.name}</h3>
        {/* Description removed as requested */}
        
        <div className="product-actions">
          <button 
            className="add-to-cart-btn"
            onClick={handleAddToCart}
            disabled={!product.inStock && !hasDownloadOption(product)}
          >
            {hasDownloadOption(product)
              ? `Choose format: from ${formatPrice(Math.min(originalPrice, Number(product.downloadPrice)))}`
              : product.inStock ? `Add to cart: ${formatPrice(originalPrice)}` : 'OUT OF STOCK'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
